/* 必須・形式エラーをフィールド下に表示し、枠線を赤くする共通バリデーション */
(function () {
  if (window.CustomFormValidation) return;

  var MSG_CLASS = 'field-error-message';

  function esc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s; }

  // フィールド名は label[for] を優先、無ければ placeholder（末尾の * は除去）
  function labelText(field) {
    var form = field.form;
    var label = field.id && form ? form.querySelector('label[for="' + esc(field.id) + '"]') : null;
    var text = label ? label.textContent : (field.getAttribute('placeholder') || '');
    return text.replace(/\s*\*\s*$/, '').trim();
  }

  function messageFor(field) {
    var name = labelText(field) || '入力項目';
    var v = field.validity;
    if (field.type === 'checkbox' && v.valueMissing) return '同意が必要です';
    if (v.valueMissing) return name + 'は必須です';
    if (v.typeMismatch && field.type === 'email') return 'メールアドレスの形式が正しくありません';
    if (v.patternMismatch) return field.title || (name + 'の形式が正しくありません');
    if (v.tooShort || v.tooLong) return name + 'の文字数をご確認ください';
    return name + 'をご確認ください';
  }

  // メッセージを差し込むフィールドブロックを求める
  function wrapperOf(field) {
    if (field.type === 'checkbox') {
      return field.closest('[class*="col-span"]') || (field.parentElement && field.parentElement.parentElement) || field.parentElement;
    }
    return field.closest('.floating-field') || field.closest('[class*="col-span"]') || field.parentElement;
  }

  function clearError(field) {
    field.removeAttribute('aria-invalid');
    if (field.__errorEl && field.__errorEl.parentNode) field.__errorEl.parentNode.removeChild(field.__errorEl);
    field.__errorEl = null;
  }

  function showError(field) {
    field.setAttribute('aria-invalid', 'true');
    var msg = field.__errorEl;
    if (!msg || !msg.parentNode) {
      msg = document.createElement('p');
      msg.className = MSG_CLASS;
      field.__errorEl = msg;
      (wrapperOf(field) || field.parentElement).appendChild(msg);
    }
    msg.textContent = messageFor(field);
  }

  function validatable(form) {
    return Array.prototype.filter.call(form.querySelectorAll('input, select, textarea'), function (f) {
      return f.willValidate && f.type !== 'hidden';
    });
  }

  // 電話番号の全角数字を半角にし、ハイフン・空白を除去する
  function normalizeTel(field) {
    if (field.type !== 'tel' || !field.value) return;
    var v = field.value
      .replace(/[０-９]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0xFEE0); })
      .replace(/[\s\-‐‑–—―−－ー]/g, '');
    if (v !== field.value) field.value = v;
  }

  // 全フィールドを検証し、エラーを描画。問題なければ true
  function validate(form) {
    var firstInvalid = null;
    validatable(form).forEach(normalizeTel);
    validatable(form).forEach(function (f) {
      if (f.checkValidity()) clearError(f);
      else { showError(f); if (!firstInvalid) firstInvalid = f; }
    });
    if (firstInvalid) { try { firstInvalid.focus(); } catch (e) {} }
    return !firstInvalid;
  }

  // エラー表示（赤枠＋メッセージ）を全て消す
  function clear(form) {
    validatable(form).forEach(clearError);
    form.querySelectorAll('.' + MSG_CLASS).forEach(function (el) { el.remove(); });
    form.querySelectorAll('[aria-invalid]').forEach(function (el) { el.removeAttribute('aria-invalid'); });
  }

  // ネイティブ吹き出しを抑止し、入力に応じてエラーを消去/表示する
  function enhance(form) {
    if (form.__validateEnhanced) return;
    form.__validateEnhanced = true;
    form.setAttribute('novalidate', 'novalidate');
    form.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches && t.matches('input, select, textarea') && t.checkValidity()) clearError(t);
    });
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches && t.matches('input, select, textarea')) { t.checkValidity() ? clearError(t) : showError(t); }
    });
    form.addEventListener('blur', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('input, select, textarea')) return;
      normalizeTel(t);
      t.checkValidity() ? clearError(t) : showError(t);
    }, true);
  }

  function attach(form) {
    enhance(form);
    if (form.__validateSubmitBound) return;
    form.__validateSubmitBound = true;
    form.addEventListener('submit', function (e) {
      if (!validate(form)) { e.preventDefault(); e.stopPropagation(); }
    });
  }

  // 外部アプリ（captcha 等）が submit を横取りして form.submit() で直接送信するケースへの防御。
  // イベントの preventDefault では止まらないため、capture 先回り + form.submit() ガードで塞ぐ。
  function installGuards() {
    if (window.__cfvGuards) return;
    window.__cfvGuards = true;

    // capture 段階で最初に検証し、無効ならアプリのハンドラごと止める
    window.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.matches && form.matches('form.js-inline-validate') && !validate(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);

    // preventDefault を無視する form.submit() 直呼びにも対応（無効なら送信させない）
    var protoSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (this && this.matches && this.matches('form.js-inline-validate') && !validate(this)) return;
      return protoSubmit.apply(this, arguments);
    };
  }

  function init() {
    installGuards();
    document.querySelectorAll('form.js-inline-validate').forEach(attach);
  }

  window.CustomFormValidation = { validate: validate, enhance: enhance, attach: attach, clear: clear };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
